




import app from "@/app";
import { OZUser } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WUserEdit extends BaseComponent {
	@Prop({ type: OZUser, required: true })
	user!: OZUser;

	form = getForm();

	updateUserInfo($event: any) {
		let ctx = this,
			form = <HTMLFormElement>$event.target,
			required = ["uname", "phone", "birth_date", "gender"],
			excluded = [],
			$mail = $(form).find("input[name=email]"),
			ofv;

		if ($mail.length) {
			if (!$.trim(String($mail.val())).length) {
				excluded.push("email");
			} else {
				required.push("email");
			}
		}

		ofv = app.getFormValidator(form, required, excluded);

		if (ofv.validate()) {
			let formData: any = {},
				oldInfo: OZUser = app.user.getCurrentUser(),
				newInfo = new OZUser(oldInfo.toObject()),
				val: any;

			if ((val = ofv.getField("uname"))) {
				formData[OZUser.COL_NAME] = val;
			}

			if ((val = ofv.getField("phone"))) {
				formData[OZUser.COL_PHONE] = val;
			}

			if ((val = ofv.getField("email"))) {
				formData[OZUser.COL_EMAIL] = val;
			}

			if ((val = ofv.getField("birth_date"))) {
				formData[OZUser.COL_BIRTH_DATE] = val;
			}

			if ((val = ofv.getField("gender"))) {
				formData[OZUser.COL_GENDER] = val;
			}

			if (!newInfo.doHydrate(formData).isClean()) {
				app.services.users.updateItem(
					newInfo,
					function(response) {
						ctx.$emit("done", response);
					},
					function(response) {
						app.view.dialog(response);
					},
					true
				);
			} else {
				ctx.$emit("ignored");
			}
		}
	}
}

let getForm = function() {
	return {
		fields: {
			uname: {
				field: "input",
				label: { i18n: "OO_LANG_USER_NAME" },
				attrs: { name: "uname", type: "text", autofocus: "autofocus" }
			},
			phone: {
				field: "phone",
				attrs: {
					name: "phone",
					autocomplete: "off"
				},
				label: { i18n: "OO_LANG_PHONE" }
			},
			email: {
				field: "input",
				label: { i18n: "OO_LANG_EMAIL" },
				attrs: { name: "email", type: "text" }
			},
			birth_date: {
				field: "input",
				label: { i18n: "OO_LANG_BIRTH_DATE" },
				attrs: { name: "birth_date", type: "date" }
			},
			gender: {
				field: "select",
				label: { i18n: "OO_LANG_SEX" },
				attrs: { name: "gender" },
				options: [
					{ value: "Male", selected: "", i18n: "OO_LANG_MALE" },
					{
						value: "Female",
						i18n: "OO_LANG_FEMALE"
					}
				]
			},
			submit: { field: "submit", i18n: "OO_LANG_VALIDATE_BTN" }
		}
	};
};
